import Component from './Criteria.vue';

export default Component;
